<template>
  <div class="flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 p-2">
    <component
      :is="props.icon"
      class="h-4 w-4 shrink-0 text-blue-700"
    />
    <p class="text-xs font-medium text-blue-700">
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
  import { Sparkles } from 'lucide-vue-next'
  import type { Component } from 'vue'

  const props = withDefaults(
    defineProps<{
      icon?: Component
    }>(),
    {
      icon: Sparkles
    }
  )
</script>
